import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**
 * État « espace parent » : l'arrêt d'autobus choisi (parmi ceux définis par le
 * manager) et le statut d'embarquement en cours, pour ne notifier/suivre que ce
 * qui concerne ce parent.
 */
interface ParentState {
  itineraryId: string | null
  stopLabel: string | null
  loaded: boolean
  /** Les enfants du parent sont montés à bord (suivi temps réel actif). */
  boarded: boolean
  /** Dernier message reçu concernant ce parent (bannière). */
  lastMessage: string | null
}

const initialState: ParentState = {
  itineraryId: null,
  stopLabel: null,
  loaded: false,
  boarded: false,
  lastMessage: null,
}

const parentSlice = createSlice({
  name: 'parent',
  initialState,
  reducers: {
    setParentStop(state, action: PayloadAction<{ itineraryId: string | null; stopLabel: string | null }>) {
      state.itineraryId = action.payload.itineraryId
      state.stopLabel = action.payload.stopLabel
      state.loaded = true
      // Changement d'arrêt → on repart d'un état neutre.
      state.boarded = false
    },
    setBoarded(state, action: PayloadAction<boolean>) {
      state.boarded = action.payload
    },
    setParentMessage(state, action: PayloadAction<string>) {
      state.lastMessage = action.payload
    },
    resetParentStatus(state) {
      state.boarded = false
      state.lastMessage = null
    },
  },
})

export const { setParentStop, setBoarded, setParentMessage, resetParentStatus } = parentSlice.actions
export default parentSlice.reducer
